import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { AdminPageHeader, adminCardClass } from '../../components/admin/AdminShared';

const VendorAccounts = () => {
  const { user, loading, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (!isAuthenticated || !user) {
        navigate('/vendor/login', { replace: true });
        return;
      }
      if (user.role !== 'vendor' && user.role !== 'admin') {
        navigate('/vendor/login', { replace: true, state: { needsVendorAccount: true } });
        return;
      }
    }
  }, [user, loading, isAuthenticated, navigate]);

  if (loading || !isAuthenticated || !user || (user.role !== 'vendor' && user.role !== 'admin')) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF7F2]">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-[#FF5E4C] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <AdminPageHeader title="Accounts" subtitle="Payouts and business settings will appear here." />
      <div className={`${adminCardClass} p-8 text-center`}>
        <p className="text-[#78736A] text-[14px]">Coming soon.</p>
      </div>
    </div>
  );
};

export default VendorAccounts;

